import Box from '@mui/material/Box';

interface PortalLogoProps {
  src: string;
  alt: string;
  /** Chiều cao ảnh logo, tính bằng px. */
  height: number;
  /**
   * Logo có chữ/hình màu sáng → tô dải nền bằng màu thương hiệu.
   * Chỉ cần ở những bề mặt SÁNG (thẻ đăng nhập). Thanh TopBar đã lấy chính
   * primary.main làm nền nên logo sáng ở đó vốn đã hiện rõ.
   */
  onDark: boolean;
}

/**
 * Đệm trên/dưới của dải nền, theo chiều cao logo.
 *
 * Trả chuỗi CSS có ĐƠN VỊ rõ ràng, không trả số. Lý do: `sx={{ py: 7 }}` được
 * MUI hiểu là 7 đơn vị spacing = 56px, nên truyền số vào đây từng thổi phồng
 * khối nền lên gấp mấy lần logo. Chuỗi `'14px'` thì không thể hiểu nhầm.
 */
export function logoBandPaddingY(height: number): string {
  return `${Math.round(height / 4)}px`;
}

/**
 * Logo của cổng truy cập trên một dải ngang chiếm trọn chiều rộng thẻ.
 *
 * Luôn là khối full-width căn giữa, dù có nền hay không — nhờ vậy logo nằm
 * đúng giữa thẻ thay vì lệch theo bề ngang ảnh. Khi `onDark`, dải được tô màu
 * thương hiệu để logo chữ sáng không chìm vào nền trắng.
 *
 * KHÔNG tự bo góc: thẻ cha đặt `overflow: 'hidden'` nên góc trên được cắt theo
 * đúng bo góc của thẻ — tránh chép giá trị bo góc ở hai nơi rồi lệch nhau.
 */
export function PortalLogo({ src, alt, height, onDark }: PortalLogoProps): JSX.Element {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        bgcolor: onDark ? 'primary.main' : 'transparent',
        paddingTop: onDark ? logoBandPaddingY(height) : 0,
        paddingBottom: onDark ? logoBandPaddingY(height) : 0,
      }}
    >
      <Box component="img" src={src} alt={alt} sx={{ height, display: 'block', maxWidth: '100%' }} />
    </Box>
  );
}
